namespace $.$$ {
	export class $bog_builderui_studio_pick extends $.$bog_builderui_studio_pick {

		title() {
			return this.option_label( this.value() )
		}

	}
}
